<template>
  <v-container fluid>
    <v-btn icon @click="$router.back()">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="display-1 pl-3" id="title">分析セット（プロトコルマスタ）管理</span>

    <v-row align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-card v-if= "!isSystemAdmin" flat outlined class="ma-5 pa-3">
          <div class="subtitle-2 mb-2">
            <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
            <span class="primary--text">メンテナンス機能について</span>
          </div>
          <p class="caption">
              この機能はシステム管理者のみ利用できる機能です。<br>
          </p>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="10">
        <div class="px-3">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="検索"
            filled
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="2">
        <div class="px-3">
          <v-checkbox
            v-model="showActiveOnly"
            label="管理対象のみ"
            dense
          ></v-checkbox>
        </div>
      </v-col>

      <v-col cols="8" xl="8" dense>
        総件数：{{filteredItems.length}}件
      </v-col>
      <v-col cols="4" xl="4" dense class="text-right">
      </v-col>

      <v-col cols="12" xl="12" dense>
        <v-data-table
          ref="dataTable"
          :headers="headers"
          :items="filteredItems"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          :sort-by="['Value']"
          :loading="loading"
          loading-text="読込中"
          no-data-text="データがありません。"          
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="(data) => { ProtocolModal(data) }"
          height="450"
          :fixed-header=true
        >
        <!--
          <template v-slot:[`item.AnalizeItems`]="{ item }">
            <span > {{ String(item.AnalizeItems).replace(/[\"\[\]]/g,"") }} </span>
          </template>
        -->
          <template v-slot:[`item.at1001`]="{ item }">
            <img v-if="item.at1001 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1001 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1001 }}</span>
          </template>
          <template v-slot:[`item.at1002`]="{ item }">
            <img v-if="item.at1002 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1002 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1002 }}</span>
          </template>
          <template v-slot:[`item.at1003`]="{ item }">
            <img v-if="item.at1003 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1003 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1003 }}</span>
          </template>
          <template v-slot:[`item.at1004`]="{ item }">
            <img v-if="item.at1004 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1004 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1004 }}</span>
          </template>
          <template v-slot:[`item.at1005`]="{ item }">
            <img v-if="item.at1005 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1005 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1005 }}</span>
          </template>
          <template v-slot:[`item.at1101`]="{ item }">
            <img v-if="item.at1101 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1101 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1101 }}</span>
          </template>
          <template v-slot:[`item.at1102`]="{ item }">
            <img v-if="item.at1102 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1102 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1102 }}</span>
          </template>
          <template v-slot:[`item.at1103`]="{ item }">
            <img v-if="item.at1103 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1103 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1103 }}</span>
          </template>
          <template v-slot:[`item.at1104`]="{ item }">
            <img v-if="item.at1104 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1104 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1104 }}</span>
          </template>
          <template v-slot:[`item.at1105`]="{ item }">
            <img v-if="item.at1105 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1105 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1105 }}</span>
          </template>
          <template v-slot:[`item.at2001`]="{ item }">
            <img v-if="item.at2001 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at2001 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at2001 }}</span>
          </template>
          <template v-slot:[`item.at3001`]="{ item }">
            <img v-if="item.at3001 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3001 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3001 }}</span>
          </template>
          <template v-slot:[`item.at3002`]="{ item }">
            <img v-if="item.at3002 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3002 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3002 }}</span>
          </template>
          <template v-slot:[`item.at3003`]="{ item }">
            <img v-if="item.at3003 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3003 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3003 }}</span>
          </template>
          <template v-slot:[`item.at3101`]="{ item }">
            <img v-if="item.at3101 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3101 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3101 }}</span>
          </template>
          <template v-slot:[`item.at3102`]="{ item }">
            <img v-if="item.at3102 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3102 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3102 }}</span>
          </template>
          <template v-slot:[`item.at3103`]="{ item }">
            <img v-if="item.at3103 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3103 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3103 }}</span>
          </template>
          <template v-slot:[`item.Price`]="{ item }">
            <div class="text-right">{{ item.Price ? Number(item.Price).toLocaleString() : '' }}</div>
          </template>
          <template v-slot:[`item.Require`]="{ item }">
            <div class="text-right">{{ item.Require ? Number(item.Require).toLocaleString() : '' }}</div>
          </template>
          <template v-slot:[`item.isActive`]="{ item }">
            <v-chip 
              small 
              :color="item.isActive === '1' ? 'green' : 'grey'" 
              class="white--text" 
              @click.stop="isSuperUser ? toggleIsActive(item) : null"
              :style="isSuperUser ? 'cursor: pointer;' : 'cursor: default;'"
            >
              {{ item.isActive === '1' ? '✔' : '✕' }}
            </v-chip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="10" lg="10" md='10' sm='10' xs="10">
        <v-pagination
         v-model="page"
         :total-visible="totalVisible"
         :length="pageCount"
         color="amber darken-1 black--text"
        light 
        circle>
        </v-pagination>
      </v-col>
      <v-col cols="4" lg="2"  md='4' sm='4' xs="6">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-select>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col v-if="isDeveloper" cols="12" xl="12" dense class="text-right">
        <v-btn 
          v-if="isSystemAdmin" 
          color="blue" 
          @click="initializeProtocolMaster"
          class="ma-2"
        >
          プロトコルマスタ初期化
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="isProtocolModal" max-width="90%">
      <v-card>
        <v-card-title primary-title class="headline grey lighten-2">
          <span class="ml-2 caption">分析セット（プロトコル）詳細:</span>
        </v-card-title>
        <v-card-text>
        <v-chip small label outlined class="mt-3 mb-3">プロトコル情報</v-chip>
        <v-chip v-if="dialogData.isActive === '0'" small color="red" class="white--text ml-3">管理対象外</v-chip>          
        <v-row dense>
          <v-col cols="2">
            <span class="ml-2 caption">分析セットコード</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ dialogData.Value }}</span>
          </v-col>
          <v-col cols="2">
            <span class="ml-2 caption">分析セット名称</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ dialogData.Text }}</span>
          </v-col>
          <v-col cols="2">
            <span class="ml-2 caption">分析料金</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ dialogData.Price ? Number(dialogData.Price).toLocaleString() : '' }}円</span>
          </v-col>
          <v-col cols="2">
            <span class="ml-2 caption">サンプル量（mL）</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ dialogData.Require ? Number(dialogData.Require).toLocaleString() : '' }}</span>
          </v-col>
          <v-col cols="2">
            <span class="ml-2 caption">登録日</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ dialogData.createdAt ? new Date(dialogData.createdAt).toLocaleString('ja-JP', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).replace(/\//g, '/') : '' }}</span>
          </v-col>
          <v-col cols="2">
            <span class="ml-2 caption">更新日</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ dialogData.updatedAt ? new Date(dialogData.updatedAt).toLocaleString('ja-JP', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).replace(/\//g, '/') : '' }}</span>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-chip small label outlined class="mt-3 mb-3">分析項目名</v-chip>
        <v-row dense>
          <v-col cols="12">
            <div class="ml-3 body-2">
              <v-chip 
                v-for="holderName in dialogData.HolderNames ? dialogData.HolderNames.split(',') : []" 
                :key="holderName" 
                small 
                class="ma-1"
                color="blue-grey lighten-4"
              >
                {{ holderName.trim() }}
              </v-chip>
            </div>
          </v-col>
        </v-row>
        
        <v-divider></v-divider>
        <v-chip small label outlined class="mt-3 mb-3">Web依頼許可状況</v-chip>          
        <v-row dense style="border: 1px solid #e0e0e0;">
          <v-col cols="2" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption"></span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">潤滑油</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">燃料</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">グリス</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">冷却水</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <span class="ml-2 body-1">水グリコール</span>
          </v-col>
        </v-row>

        <v-row dense style="border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
          <v-col cols="2" class="d-flex align-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">一般：社定法</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1001"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1002"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1003"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1004"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <v-switch
              v-model="switchAt1005"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
        </v-row>

        <v-row dense style="border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
          <v-col cols="2" class="d-flex align-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">一般：公定法</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1101"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1102"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1103"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1104"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <v-switch
              v-model="switchAt1105"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
        </v-row>

        <v-row dense style="border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
          <v-col cols="2" class="d-flex align-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">JET：社定法</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt2001"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption">ー</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption">ー</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption">ー</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <span class="ml-2 caption">ー</span>
          </v-col>
        </v-row>

        <v-row dense style="border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
          <v-col cols="2" class="d-flex align-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">JXTG：社定法</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3001"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3002"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3003"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption">ー</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <span class="ml-2 caption">ー</span>
          </v-col>
        </v-row>

        <v-row dense style="border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
          <v-col cols="2" class="d-flex align-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">JXTG：公定法</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3101"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3102"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3103"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption">ー</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <span class="ml-2 caption">ー</span>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-chip small label outlined class="mt-3 mb-3">依頼許可得意先</v-chip>
        <v-row dense>
          <v-col cols="12">
            <span class="ml-2 caption">この分析セットの依頼が許可されている得意先コード：</span>
            <div class="ml-3 body-2">
              <span v-if="companyList.length === 0" class="grey--text">登録されている得意先がありません</span>
              <v-chip 
                v-for="company in companyList" 
                :key="company" 
                small 
                class="ma-1"
                :color="company === '0000000000' ? 'primary' : 'default'"
                :text-color="company === '0000000000' ? 'white' : 'default'"
                :close="isSuperUser"
                @click:close="removeCompany(company)"
              >
                {{ company === '0000000000' ? '共通' : company }}
              </v-chip>
            </div>
            
            <!-- 企業追加用入力フィールド -->
            <v-row v-if="isSuperUser" dense class="mt-2">
              <v-col cols="8">
                <v-text-field
                  v-model="newCompanyInput"
                  label="依頼できる得意先コードを入力"
                  placeholder="例: 1234567890 または 0000000000(共通)"
                  dense
                  outlined
                  @keyup.enter="addCompany"
                  @input="showEmptyError = false"
                  :error-messages="companyInputErrors"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-btn 
                  rounded 
                  color="amber darken-3" 
                  @click="addCompany"
                >
                  得意先を追加
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-chip small label outlined class="mt-3 mb-3">説明</v-chip>
        <v-row dense>
          <v-col cols="12">
            <v-textarea
              v-model="dialogData.Description"
              label="説明"
              :disabled="!isSuperUser"
              rows="3"
              outlined
              dense
            ></v-textarea>
          </v-col>
        </v-row>

      </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="amber darken-3" rounded @click="updateData" :disabled="!isSuperUser" class="ma-4">変更</v-btn>
          <v-btn rounded @click="isProtocolModal=false" class="ma-4">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 変更確認用のダイアログ -->
    <v-dialog v-model="isChangeConfirmDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">変更確認</v-card-title>
        <v-card-text>
          <div v-if="changesList.length > 0">
            <p>以下の項目を変更します。よろしいですか？</p>
            <div v-for="change in changesList" :key="change" class="mb-2">
              <div v-if="change.includes('→')">
                <div class="body-2 mb-1 font-weight-bold">{{ change.split(':')[0] }}:</div>
                <div class="ml-4">
                  <template v-if="change.startsWith('説明')">
                    <div class="caption mb-1">変更前:</div>
                    <div class="body-2 mb-2 pa-2" style="background-color: #f5f5f5; border-radius: 4px;">
                      {{ change.split('→')[0].split('\n    ')[1] }}
                    </div>
                    <div class="caption mb-1">変更後:</div>
                    <div class="body-2 pa-2" style="background-color: #e8f5e8; border-radius: 4px;">
                      {{ change.split('→')[1].trim() }}
                    </div>
                  </template>
                  <template v-else>
                    <v-chip 
                      small 
                      :color="change.includes('依頼できない →') ? 'grey' : 'green'" 
                      :text-color="'white'"
                      class="mr-2"
                    >
                      {{ change.includes('依頼できない →') ? '依頼できない' : '依頼できる' }}
                    </v-chip>
                    <span class="mx-2">→</span>
                    <v-chip 
                      small 
                      :color="change.includes('→ 依頼できる') ? 'green' : 'grey'" 
                      :text-color="'white'"
                    >
                      {{ change.includes('→ 依頼できる') ? '依頼できる' : '依頼できない' }}
                    </v-chip>
                  </template>
                </div>
              </div>
              <div v-else-if="change.includes('追加') || change.includes('削除')" class="d-flex align-center">
                <v-chip 
                  small 
                  color="green" 
                  text-color="white"
                  class="mr-2"
                >
                  {{ change.replace(' 追加', '').replace(' 削除', '') }}
                </v-chip>
                <v-chip 
                  small 
                  :color="change.includes('追加') ? 'green' : 'grey'" 
                  text-color="white"
                >
                  {{ change.includes('追加') ? '依頼できる' : '依頼できない' }}
                </v-chip>
              </div>
              <div v-else class="body-2">
                {{ change }}
              </div>
            </div>
          </div>
          <div v-else>
            変更はありませんでした。
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="amber darken-1" @click="confirmUpdate">OK</v-btn>
          <v-btn rounded @click="isChangeConfirmDialog = false">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { listProtocols, sortedAnalizeSetByType } from '../graphql/queries'
import { updateProtocol, createAnalizeSet, updateAnalizeSet } from '../graphql/mutations'
import mixin from '../utils/mixin'

export default {

  name: "listProtocols",
  mixins:[mixin],
  head: {
    title: { inner: '分析セット（プロトコル）一覧'},
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      itemsPerPageList: [ 50,100, ],
      totalVisible: 7,
      search: '',
      showActiveOnly: true,
      loading: false, 
      isProtocolModal: false,
      isChangeConfirmDialog: false,
      selectedItemIndex: -1,
      originalData: {},
      changesList: [],
      companyList: [],
      originalCompanyList: [],
      newCompanyInput: '',
      showEmptyError: false,
      showCompanyRequiredError: false,

      dialogData: {
        at1001: '0',
        at1002: '0',
        at1003: '0',
        at1004: '0',
        at1005: '0',
        at1101: '0',
        at1102: '0',
        at1103: '0',
        at1104: '0',
        at1105: '0',
        at2001: '0',
        at3001: '0',
        at3002: '0',
        at3003: '0',
        at3101: '0',
        at3102: '0',
        at3103: '0'
      },

      items: [],
      headers: [
        {
          text: 'コード',
          align: 'start',
          value: 'Value',
          class: "grey darken-2 white--text",
          width: "8%" ,
          sortable: false
        },
        {
          text: '分析セット名',
          align: 'start',
          value: 'Text',
          class: "grey darken-2 white--text",
          width: "14%",
          sortable: false 
        },
        {
          text: '分析料金',
          align: 'start',
          value: 'Price',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: false 
        },
        {
          text: 'サンプル量（mL）',
          align: 'start',
          value: 'Require',
          class: "grey darken-2 white--text",
          width: "10%",
          sortable: false 
        },
        {
          text: '社_潤滑油',
          align: 'start',
          value: 'at1001',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '社_燃料',
          align: 'start',
          value: 'at1002',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '社_グリス',
          align: 'start',
          value: 'at1003',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '社_冷却水',
          align: 'start',
          value: 'at1004',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '社_水グリ',
          align: 'start',
          value: 'at1005',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '公_潤滑油',
          align: 'start',
          value: 'at1101',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '公_燃料',
          align: 'start',
          value: 'at1102',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '公_グリス',
          align: 'start',
          value: 'at1103',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '公_冷却水',
          align: 'start',
          value: 'at1104',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '公_水グリ',
          align: 'start',
          value: 'at1105',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JET_潤滑油',
          align: 'start',
          value: 'at2001',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX社_潤滑油',
          align: 'start',
          value: 'at3001',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX社_燃料',
          align: 'start',
          value: 'at3002',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX社_グリス',
          align: 'start',
          value: 'at3003',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX公_潤滑油',
          align: 'start',
          value: 'at3101',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX公_燃料',
          align: 'start',
          value: 'at3102',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX公_グリス',
          align: 'start',
          value: 'at3103',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '管理',
          align: 'start',
          value: 'isActive',
          class: "grey darken-2 white--text",
          width: "2%",
          sortable: false 
        },
      ],
    }
  },
  validations() {
    return {
      companyList: {
        required: function() {
          // 何かの分析区分がONの場合は企業コードが必須
          const hasActiveField = [
            'at1001', 'at1002', 'at1003', 'at1004', 'at1005',
            'at1101', 'at1102', 'at1103', 'at1104', 'at1105',
            'at2001', 'at3001', 'at3002', 'at3003',
            'at3101', 'at3102', 'at3103'
          ].some(field => this.dialogData[field] === '1')
          
          return !hasActiveField || this.companyList.length > 0
        }
      }
    }
  },
  filters: {
  },
  computed: {
    isSuperUser () {
      return this.$store.state.isSuperUser
    },
    isDeveloper () {
      return this.$store.state.isDeveloper
    },
    isSystemAdmin : function() {
      return this.$store.state.isSystemAdmin
    },
    switchAt1001: {
      get() {
        return this.dialogData.at1001 === '1'
      },
      set(value) {
        this.dialogData.at1001 = value ? '1' : '0'
      }
    },
    switchAt1002: {
      get() { return this.dialogData.at1002 === '1' },
      set(value) { this.dialogData.at1002 = value ? '1' : '0' }
    },
    switchAt1003: {
      get() { return this.dialogData.at1003 === '1' },
      set(value) { this.dialogData.at1003 = value ? '1' : '0' }
    },
    switchAt1004: {
      get() { return this.dialogData.at1004 === '1' },
      set(value) { this.dialogData.at1004 = value ? '1' : '0' }
    },
    switchAt1005: {
      get() { return this.dialogData.at1005 === '1' },
      set(value) { this.dialogData.at1005 = value ? '1' : '0' }
    },
    switchAt1101: {
      get() { return this.dialogData.at1101 === '1' },
      set(value) { this.dialogData.at1101 = value ? '1' : '0' }
    },
    switchAt1102: {
      get() { return this.dialogData.at1102 === '1' },
      set(value) { this.dialogData.at1102 = value ? '1' : '0' }
    },
    switchAt1103: {
      get() { return this.dialogData.at1103 === '1' },
      set(value) { this.dialogData.at1103 = value ? '1' : '0' }
    },
    switchAt1104: {
      get() { return this.dialogData.at1104 === '1' },
      set(value) { this.dialogData.at1104 = value ? '1' : '0' }
    },
    switchAt1105: {
      get() { return this.dialogData.at1105 === '1' },
      set(value) { this.dialogData.at1105 = value ? '1' : '0' }
    },
    switchAt2001: {
      get() { return this.dialogData.at2001 === '1' },
      set(value) { this.dialogData.at2001 = value ? '1' : '0' }
    },
    switchAt3001: {
      get() { return this.dialogData.at3001 === '1' },
      set(value) { this.dialogData.at3001 = value ? '1' : '0' }
    },
    switchAt3002: {
      get() { return this.dialogData.at3002 === '1' },
      set(value) { this.dialogData.at3002 = value ? '1' : '0' }
    },
    switchAt3003: {
      get() { return this.dialogData.at3003 === '1' },
      set(value) { this.dialogData.at3003 = value ? '1' : '0' }
    },
    switchAt3101: {
      get() { return this.dialogData.at3101 === '1' },
      set(value) { this.dialogData.at3101 = value ? '1' : '0' }
    },
    switchAt3102: {
      get() { return this.dialogData.at3102 === '1' },
      set(value) { this.dialogData.at3102 = value ? '1' : '0' }
    },
    switchAt3103: {
      get() { return this.dialogData.at3103 === '1' },
      set(value) { this.dialogData.at3103 = value ? '1' : '0' }
    },
    companyListErrors() {
      const errors = []
      if (!this.$v.companyList.$dirty) return errors
      !this.$v.companyList.required && errors.push('分析区分が有効な場合は、少なくとも一つの企業コードを指定してください。')
      return errors
    },
    companyInputErrors() {
      const errors = []
      const companyCode = this.newCompanyInput.trim()
      
      if (this.showEmptyError && !companyCode) {
        errors.push('企業コードを入力してください')
      }
      
      if (this.showCompanyRequiredError) {
        errors.push('分析区分が有効な場合は、少なくとも一つの企業コードを登録してください')
      }
      
      if (companyCode && !/^\d{10}$/.test(companyCode)) {
        errors.push('企業コードは10文字の数字で入力してください')
      }
      
      if (companyCode && this.companyList.includes(companyCode)) {
        errors.push('この企業コードは既に追加されています')
      }
      
      return errors
    },
    filteredItems() {
      if (this.showActiveOnly) {
        return this.items.filter(item => item.isActive === '1')
      }
      return this.items
    }
  },
  mounted: async function () {
    this.initialize()
  },
  watch: {
    page() {
      this.$nextTick(() => {
        const tableWrapper = this.$refs.dataTable.$el.querySelector('.v-data-table__wrapper')
        if (tableWrapper) {
          tableWrapper.scrollTop = 0
        }
      })
    }
  },
  methods: {
    initialize: async function() {
      let items = await API.graphql(graphqlOperation(listProtocols, {limit: 999}))
      this.items = items.data.listProtocols.items
    },
    ProtocolModal: async function(data) {
      this.selectedItemIndex = this.items.findIndex(item => item.Value === data.Value)
      
      // Company一覧を取得（主要な分析区分を検索）
      try {
        let allCompanies = []
        // 主要な分析区分を検索
        const analizeTypes = ["1001", "1002", "1003", "1004", "1005", "1101", "1102", "1103", "1104", "1105", "2001", "3001", "3002", "3003", "3101", "3102", "3103"]
        
        for (const analizeType of analizeTypes) {
          try {
            const companies = await this.getAnalizeSetCompanyList(analizeType, data.Value)
            allCompanies = allCompanies.concat(companies)
          } catch (error) {
            // エラーがあっても続行
            console.log(`分析区分 ${analizeType} での検索でエラー:`, error)
          }
        }
        
        // 重複を除去
        this.companyList = [...new Set(allCompanies)]
        // 元の企業リストを保存
        this.originalCompanyList = [...this.companyList]
      } catch (error) {
        console.log("Company一覧の取得に失敗:", error)
        this.companyList = []
        this.originalCompanyList = []
      }
      
      // 元のデータを保存
      this.originalData = {
        ...data,
        at1001: data.at1001,
        at1002: data.at1002,
        at1003: data.at1003,
        at1004: data.at1004,
        at1005: data.at1005,
        at1101: data.at1101,
        at1102: data.at1102,
        at1103: data.at1103,
        at1104: data.at1104,
        at1105: data.at1105,
        at2001: data.at2001,
        at3001: data.at3001,
        at3002: data.at3002,
        at3003: data.at3003,
        at3101: data.at3101,
        at3102: data.at3102,
        at3103: data.at3103,
        Description: data.Description
      }
      // 編集用データを作成
      this.dialogData = {
        ...data,
        at1001: data.at1001,
        at1002: data.at1002,
        at1003: data.at1003,
        at1004: data.at1004,
        at1005: data.at1005,
        at1101: data.at1101,
        at1102: data.at1102,
        at1103: data.at1103,
        at1104: data.at1104,
        at1105: data.at1105,
        at2001: data.at2001,
        at3001: data.at3001,
        at3002: data.at3002,
        at3003: data.at3003,
        at3101: data.at3101,
        at3102: data.at3102,
        at3103: data.at3103
      }
      this.showEmptyError = false
      this.showCompanyRequiredError = false
      this.isProtocolModal = true  
    },
    updateData: function() {
      if (this.selectedItemIndex >= 0) {
        // 企業コードのバリデーションチェック
        const hasActiveField = [
          'at1001', 'at1002', 'at1003', 'at1004', 'at1005',
          'at1101', 'at1102', 'at1103', 'at1104', 'at1105',
          'at2001', 'at3001', 'at3002', 'at3003',
          'at3101', 'at3102', 'at3103'
        ].some(field => this.dialogData[field] === '1')
        
        if (hasActiveField && this.companyList.length === 0) {
          this.showCompanyRequiredError = true
          return
        }
        
        this.showCompanyRequiredError = false
        
        // バリデーションチェック
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }
        
        // 変更内容をチェック
        const changes = []
        const fieldNames = {
          at1001: '一般：社定法_潤滑油',
          at1002: '一般：社定法_燃料',
          at1003: '一般：社定法_グリス',
          at1004: '一般：社定法_冷却水',
          at1005: '一般：社定法_水グリコール',
          at1101: '一般：公定法_潤滑油',
          at1102: '一般：公定法_燃料',
          at1103: '一般：公定法_グリス',
          at1104: '一般：公定法_冷却水',
          at1105: '一般：公定法_水グリコール',
          at2001: 'JET：社定法_潤滑油',
          at3001: 'JXTG_社定法_潤滑油',
          at3002: 'JXTG_社定法_燃料',
          at3003: 'JXTG_社定法_グリス',
          at3101: 'JXTG_社定法_潤滑油',
          at3102: 'JXTG_社定法_燃料',
          at3103: 'JXTG_社定法_グリス'
        }
        
        Object.keys(fieldNames).forEach(field => {
          if (this.originalData[field] !== this.dialogData[field]) {
            const oldValue = this.originalData[field] === '1' ? '依頼できる' : '依頼できない'
            const newValue = this.dialogData[field] === '1' ? '依頼できる' : '依頼できない'
            changes.push(`${fieldNames[field]}: \n    ${oldValue} → ${newValue}`)
          }
        })
        
        // Descriptionの変更をチェック
        if (this.originalData.Description !== this.dialogData.Description) {
          const oldDesc = this.originalData.Description || '(空)'
          const newDesc = this.dialogData.Description || '(空)'
          changes.push(`説明: \n    ${oldDesc} → ${newDesc}`)
        }
        
        // 企業リストの変更をチェック
        const originalCompanies = this.originalCompanyList
        const currentCompanies = this.companyList
        
        // 削除された企業を検出
        const removedCompanies = originalCompanies.filter(company => !currentCompanies.includes(company))
        // 追加された企業を検出
        const addedCompanies = currentCompanies.filter(company => !originalCompanies.includes(company))
        
        // 削除された企業を表示
        removedCompanies.forEach(company => {
          const displayName = company === '0000000000' ? '共通' : company
          changes.push(`${displayName} 削除`)
        })
        
        // 追加された企業を表示
        addedCompanies.forEach(company => {
          const displayName = company === '0000000000' ? '共通' : company
          changes.push(`${displayName} 追加`)
        })
        
        this.changesList = changes
        this.isChangeConfirmDialog = true
      }
    },
    confirmUpdate: async function() {
      console.log('Updated data:', this.dialogData)

      // Protocolテーブルの更新
      let protocol = {}
      try {
        protocol["id"] = this.items[this.selectedItemIndex].id
        protocol["at1001"] = this.dialogData["at1001"]
        protocol["at1002"] = this.dialogData["at1002"]
        protocol["at1003"] = this.dialogData["at1003"]
        protocol["at1004"] = this.dialogData["at1004"]
        protocol["at1005"] = this.dialogData["at1005"]
        protocol["at1101"] = this.dialogData["at1101"]
        protocol["at1102"] = this.dialogData["at1102"]
        protocol["at1103"] = this.dialogData["at1103"]
        protocol["at1104"] = this.dialogData["at1104"]
        protocol["at1105"] = this.dialogData["at1105"]
        protocol["at2001"] = this.dialogData["at2001"]
        protocol["at3001"] = this.dialogData["at3001"]
        protocol["at3002"] = this.dialogData["at3002"]
        protocol["at3003"] = this.dialogData["at3003"]
        protocol["at3101"] = this.dialogData["at3101"]
        protocol["at3102"] = this.dialogData["at3102"]
        protocol["at3103"] = this.dialogData["at3103"]
        protocol["Description"] = this.dialogData["Description"] || ''

        console.log("protocol update", protocol);
        await API.graphql(graphqlOperation(updateProtocol, {input: protocol}))
      } catch (err) {
        console.log("update protocol error", JSON.stringify(err));
        console.log("update protocol param", protocol);
      }

      // AnalizeSetテーブルの更新処理
      await this.updateAnalizeSetTable()

      if (this.selectedItemIndex >= 0) {
        Object.assign(this.items[this.selectedItemIndex], this.dialogData)
      }
      this.isChangeConfirmDialog = false
      this.isProtocolModal = false
    },
    addCompany: function() {
      const companyCode = this.newCompanyInput.trim()
      console.log('addCompany called, companyCode:', companyCode)
      
      if (!companyCode) {
        console.log('Setting showEmptyError to true')
        this.showEmptyError = true
        return
      }
      if (!/^\d{10}$/.test(companyCode)) return
      if (this.companyList.includes(companyCode)) return
      
      this.showEmptyError = false
      this.showCompanyRequiredError = false
      this.companyList.push(companyCode)
      this.newCompanyInput = ''
    },
    removeCompany: function(company) {
      const index = this.companyList.indexOf(company)
      if (index > -1) {
        this.companyList.splice(index, 1)
      }
    },

    updateAnalizeSetTable: async function() {
      const fieldToAnalizeType = {
        at1001: '1001',
        at1002: '1002', 
        at1003: '1003',
        at1004: '1004',
        at1005: '1005',
        at1101: '1101',
        at1102: '1102',
        at1103: '1103', 
        at1104: '1104',
        at1105: '1105',
        at2001: '2001',
        at3001: '3001',
        at3002: '3002',
        at3003: '3003',
        at3101: '3101',
        at3102: '3102',
        at3103: '3103'
      }

      // Descriptionの変更をチェック
      const descriptionChanged = this.originalData.Description !== this.dialogData.Description
      if (descriptionChanged) {
        await this.updateAllAnalizeSetDescription()
      }

      // 企業リストの変更をチェック
      const originalCompanies = this.originalCompanyList
      const currentCompanies = this.companyList
      const removedCompanies = originalCompanies.filter(company => !currentCompanies.includes(company))
      const addedCompanies = currentCompanies.filter(company => !originalCompanies.includes(company))
      const companyListChanged = removedCompanies.length > 0 || addedCompanies.length > 0

      for (const [field, analizeType] of Object.entries(fieldToAnalizeType)) {
        const originalValue = this.originalData[field]
        const newValue = this.dialogData[field]
        
        if (originalValue !== newValue) {
          if (newValue === '1') {
            // ONになった場合：指定された企業の分だけレコードを追加
            for (const company of this.companyList) {
              await this.createOrUpdateAnalizeSet(analizeType, company, '1')
            }
          } else {
            // OFFになった場合：全企業のisActiveを"0"にする
            await this.deactivateAnalizeSetForAllCompanies(analizeType)
          }
        } else if (newValue === '1' && companyListChanged) {
          // 分析区分は変更なしでON状態だが、企業リストが変更された場合
          
          // 削除された企業のレコードを非アクティブ化
          for (const company of removedCompanies) {
            await this.deactivateAnalizeSetForCompany(analizeType, company)
          }
          
          // 追加された企業のレコードを作成/アクティブ化
          for (const company of addedCompanies) {
            await this.createOrUpdateAnalizeSet(analizeType, company, '1')
          }
        }
      }
    },
    updateAllAnalizeSetDescription: async function() {
      try {
        console.log(`${this.dialogData.Value}の説明を更新`)
        // 該当するValueの全AnalizeSetレコードを取得
        const allRecords = await this.getAnalizeSetByValue(this.dialogData.Value)
        
        // 全レコードのDescriptionを更新
        for (const record of allRecords) {
          await API.graphql(graphqlOperation(updateAnalizeSet, {
            input: {
              id: record.id,
              Description: this.dialogData.Description || ''
            }
          }))
        }
        console.log(`${allRecords.length}件のAnalizeSetのDescriptionを更新しました`)
      } catch (error) {
        console.log('AnalizeSet Description更新エラー:', error)
      }
    },
    createOrUpdateAnalizeSet: async function(analizeType, company, isActive) {
      try {
        // 既存レコードを検索
        const existingRecords = await this.getAnalizeSetByTypeAndValue(analizeType, this.dialogData.Value, company)
        
        if (existingRecords.length > 0) {
          // 既存レコードを更新
          const record = existingRecords[0]
          await API.graphql(graphqlOperation(updateAnalizeSet, {
            input: {
              id: record.id,
              isActive: isActive
            }
          }))
        } else {
          // 新しいレコードを作成
          await API.graphql(graphqlOperation(createAnalizeSet, {
            input: {
              Company: company,
              AnalizeType: analizeType,
              Text: this.dialogData.Text,
              Value: this.dialogData.Value,
              Price: this.dialogData.Price || 0,
              Require: this.dialogData.Require || 0,
              AnalizeItems: this.convertToJsonArray(this.dialogData.Holders),
              AnalizeItemNames: this.convertToJsonArray(this.dialogData.HolderNames),
              Description: this.dialogData.Description || '',
              isActive: isActive
            }
          }))
        }
      } catch (error) {
        console.log(`AnalizeSetの作成/更新エラー (${analizeType}, ${company}):`, error)
      }
    },
    deactivateAnalizeSetForAllCompanies: async function(analizeType) {
      try {
        // 該当する全レコードを取得
        const allRecords = await this.getAnalizeSetByTypeAndValue(analizeType, this.dialogData.Value)
        
        // 全レコードのisActiveを"0"に更新
        for (const record of allRecords) {
          await API.graphql(graphqlOperation(updateAnalizeSet, {
            input: {
              id: record.id,
              isActive: '0'
            }
          }))
        }
      } catch (error) {
        console.log(`AnalizeSetの非アクティブ化エラー (${analizeType}):`, error)
      }
    },
    deactivateAnalizeSetForCompany: async function(analizeType, company) {
      try {
        // 特定の企業のレコードを取得
        const records = await this.getAnalizeSetByTypeAndValue(analizeType, this.dialogData.Value, company)
        
        // 該当レコードのisActiveを"0"に更新
        for (const record of records) {
          await API.graphql(graphqlOperation(updateAnalizeSet, {
            input: {
              id: record.id,
              isActive: '0'
            }
          }))
        }
      } catch (error) {
        console.log(`AnalizeSetの非アクティブ化エラー (${analizeType}, ${company}):`, error)
      }
    },
    getAnalizeSetByTypeAndValue: async function(analizeType, value, company = null) {
      try {
        const result = await API.graphql(graphqlOperation(sortedAnalizeSetByType, {
          AnalizeType: analizeType,
          Value: { eq: value },
          filter: company ? { Company: { eq: company } } : undefined
        }))
        
        return result.data.sortedAnalizeSetByType.items || []
      } catch (error) {
        console.log('getAnalizeSetByTypeAndValue error:', error)
        return []
      }
    },
    convertToJsonArray: function(csvString) {
      if (!csvString || csvString.trim() === '') {
        return '[]'
      }
      const items = csvString.split(',').map(item => item.trim())
      return JSON.stringify(items)
    },
    getHolderByValue: async function(value) {
      try {
        const { listHolders } = await import('../graphql/queries')
        const result = await API.graphql(graphqlOperation(listHolders, {
          filter: { Value: { eq: value } }
        }))
        return result.data.listHolders.items[0] || null
      } catch (error) {
        console.log('getHolderByValue error:', error)
        return null
      }
    },
    getAnalizeSetByValue: async function(value) {
      try {
        const { listAnalizeSets } = await import('../graphql/queries')
        const result = await API.graphql(graphqlOperation(listAnalizeSets, {
          filter: { Value: { eq: value } },
          limit: 999
        }))
        return result.data.listAnalizeSets.items || []
      } catch (error) {
        console.log('getAnalizeSetByValue error:', error)
        return []
      }
    },
    initializeProtocolMaster: async function() {
      if (!confirm('プロトコルマスタを初期化します。\n\n注意：この操作により、全てのプロトコルの分析区分が一旦リセットされ、AnalizeSetテーブルのisActive="1"の項目に基づいて再設定されます。\n\nよろしいですか？')) {
        return
      }

      try {
        // 1. 全Protocolのat1001等をすべて"0"に更新
        const updatePromises = this.items.map(async (protocol) => {
          const updateInput = {
            id: protocol.id,
            at1001: "0",
            at1002: "0",
            at1003: "0",
            at1004: "0",
            at1005: "0",
            at1101: "0",
            at1102: "0",
            at1103: "0",
            at1104: "0",
            at1105: "0",
            at2001: "0",
            at3001: "0",
            at3002: "0",
            at3003: "0",
            at3101: "0",
            at3102: "0",
            at3103: "0",
            isActive: "1" 
          }
          await API.graphql(graphqlOperation(updateProtocol, { input: updateInput }))
        })
        
        await Promise.all(updatePromises)
        console.log('全Protocolの分析区分を"0"に初期化完了')

        // 2. AnalizeSetテーブルからisActive="1"の項目を検索し、対応するProtocolを更新
        const analizeTypeToField = {
          '1001': 'at1001',
          '1002': 'at1002',
          '1003': 'at1003',
          '1004': 'at1004',
          '1005': 'at1005',
          '1101': 'at1101',
          '1102': 'at1102',
          '1103': 'at1103',
          '1104': 'at1104',
          '1105': 'at1105',
          '2001': 'at2001',
          '3001': 'at3001',
          '3002': 'at3002',
          '3003': 'at3003',
          '3101': 'at3101',
          '3102': 'at3102',
          '3103': 'at3103'
        }

        // 各分析区分ごとにAnalizeSetを検索
        for (const [analizeType, fieldName] of Object.entries(analizeTypeToField)) {
          try {
            const { listAnalizeSets } = await import('../graphql/queries')
            const analizeSets = await API.graphql(graphqlOperation(listAnalizeSets, {
              filter: {
                AnalizeType: { eq: analizeType },
                or: [
                  { isActive: { eq: "1" } },
                  { isActive: { attributeExists: false } }
                ]
              },
              limit: 999
            }))

            // 該当するAnalizeSetのValueでProtocolを検索し、対応するフィールドを"1"に更新
            for (const analizeSet of analizeSets.data.listAnalizeSets.items) {
              const protocolToUpdate = this.items.find(protocol => protocol.Value === analizeSet.Value)
              if (protocolToUpdate) {
                const updateInput = {
                  id: protocolToUpdate.id,
                  [fieldName]: "1",
                  Description: analizeSet.Description || ''
                }
                await API.graphql(graphqlOperation(updateProtocol, { input: updateInput }))
                console.log(`Updated Protocol ${protocolToUpdate.Value} ${fieldName} to "1"`)
              }
            }
          } catch (error) {
            console.log(`Error processing AnalizeType ${analizeType}:`, error)
          }
        }

        // 3. 画面を再読み込み
        await this.initialize()
        alert('プロトコルマスタの初期化が完了しました。')
      } catch (error) {
        console.log('プロトコルマスタ初期化エラー:', error)
        alert('プロトコルマスタの初期化中にエラーが発生しました。')
      }
    },
    toggleIsActive: async function(item) {
      try {
        const newIsActive = item.isActive === '1' ? '0' : '1'
        
        await API.graphql(graphqlOperation(updateProtocol, {
          input: {
            id: item.id,
            isActive: newIsActive
          }
        }))
        
        // ローカルデータを更新
        item.isActive = newIsActive
        
        console.log(`Protocol ${item.Value} isActive updated to ${newIsActive}`)
      } catch (error) {
        console.error('Error updating isActive:', error)
      }
    },
  }
};
</script>
